import React from 'react';

const MyTIDataTools = () => {
  return <div>DataTools</div>;
};

export default MyTIDataTools;
